var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.147 3.42896C7.41399 3.42896 3.57599 7.26696 3.57599 12H0.717987L4.42299 15.705L4.48999 15.838L8.33699 12H5.47999C5.47999 8.31396 8.46099 5.33296 12.147 5.33296C15.833 5.33296 18.813 8.31396 18.813 12C18.813 15.686 15.832 18.667 12.146 18.667C10.308 18.667 8.64099 17.915 7.44099 16.705L6.08899 18.057C7.64099 19.609 9.77499 20.571 12.146 20.571C16.879 20.571 20.717 16.733 20.717 12C20.717 7.26696 16.88 3.42896 12.147 3.42896ZM11.194 8.18995V12.952L15.27 15.371L15.956 14.219L12.623 12.238V8.18995H11.194Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.742a55ef61edd3ad74e53f29a22fee2b.svg";
export { ForwardRef as ReactComponent };